import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navigationLinks } from './Navigation/navigationLinks';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-8">
        {navigationLinks.map(({ to, icon: Icon, text }) => (
          <Link
            key={to}
            to={to}
            className="flex items-center space-x-2 text-gray-600 hover:text-green-600 transition-colors"
          >
            <Icon className="h-5 w-5" />
            <span>{text}</span>
          </Link>
        ))}
      </nav>

      {/* Mobile Navigation Button */}
      <div className="md:hidden">
        <button
          className="p-2 text-gray-600 hover:text-green-600"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <div className="fixed inset-0 z-50">
            {/* Backdrop */}
            <div 
              className="fixed inset-0 bg-black/20 backdrop-blur-sm"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Menu Panel */}
            <div className="absolute top-0 right-0 w-64 h-full bg-white shadow-lg">
              <div className="flex flex-col p-4">
                {navigationLinks.map(({ to, icon: Icon, text }) => (
                  <Link
                    key={to}
                    to={to}
                    className="flex items-center space-x-2 px-4 py-3 text-gray-600 hover:text-green-600 hover:bg-gray-50 rounded-lg transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    <Icon className="h-5 w-5" />
                    <span>{text}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}